import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHead: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHead"><Path d="M18.5 18.3333H14.5V21.5H6.5C6.5 18.8355 6.82469 16.6599 5.07938 14.4455C4.08996 13.1901 3.5 11.6081 3.5 9.88889C3.5 5.80812 6.82395 2.5 10.9242 2.5C13.9468 2.5 16.7298 3.94383 17.877 6.86239C18.6809 8.90747 19.7678 10.1605 21 12L18.5 13.5833V18.3333Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHead;
